import { rangeInput } from 'instantsearch.js/es/widgets';

export const initRangeInput = algoliaSearch => {
	const rangeInputTargetDiv = document.querySelector('#rangeInput');

	const handleInputEvents = event => {
		const submitBtn = rangeInputTargetDiv.querySelector(
			'.ais-RangeInput-submit',
		);
		if (submitBtn && event.type === 'blur') {
			submitBtn.click();

			if (!event.target.value) {
				const placeHolderValue = event.target.classList.contains(
					'ais-RangeInput-input--min',
				)
					? event.target.min
					: event.target.max;
				event.target.placeholder = placeHolderValue;
			}
		}
	};

	const clearInputOnFocus = event => {
		event.target.placeholder = '';
	};

	const attachInputListeners = () => {
		const rangeInputs = rangeInputTargetDiv.querySelectorAll(
			'.ais-RangeInput-input',
		);
		rangeInputs.forEach(rangeInputField => {
			rangeInputField.addEventListener('click', clearInputOnFocus);
			rangeInputField.addEventListener('blur', handleInputEvents);
		});
	};

	algoliaSearch.on('render', () => {
		const hasResults = algoliaSearch.helper?.lastResults?.hits.length > 0;
		rangeInputTargetDiv.classList.toggle('d-none', !hasResults);

		attachInputListeners();
	});

	return rangeInput({
		container: rangeInputTargetDiv,
		attribute: 'price.priceValue',
	});
};
